import React, { useState, createContext, ReactNode } from 'react'
import ReduxWrapper from './ReduxWrapper'

interface GlobalContextType {
  location: string | undefined;
  saveLocation: (location: string) => void;
  themeDark: boolean;
  toggleTheme: () => void;
  headerDark: boolean;
  goHeaderDark: () => void;
  goHeaderLight: () => void;
  footerDark: boolean;
  goFooterDark: () => void;
  goFooterLight: () => void;
  videoModalVisible: boolean;
  toggleVideoModal: () => void;
  visibleOffCanvas: boolean;
  toggleOffCanvas: () => void;
  cartTotal: number;
  incCartTotal: () => void;
  decCartTotal: () => void;
}

interface GlobalProviderProps {
  children: ReactNode;
}

const GlobalContext = createContext<GlobalContextType | undefined>(undefined)

const GlobalProvider: React.FC<GlobalProviderProps> = ({ children }) => {
  const [themeDark, setThemeDark] = useState<boolean>(false)
  const [videoModalVisible, setVideoModalVisible] = useState<boolean>(false)
  const [visibleOffCanvas, setVisibleOffCanvas] = useState<boolean>(false)
  const [headerDark, setHeaderDark] = useState<boolean>(false)
  const [footerDark, setFooterDark] = useState<boolean>(true)
  const [cartTotal, setCartTotal] = useState<number>(3)
  const [location, setLocation] = useState<string | undefined>()

  const saveLocation = (location: string): void => {
    setLocation(location)
  }

  const toggleTheme = (): void => {
    setThemeDark(!themeDark)
  }

  const toggleVideoModal = (): void => {
    setVideoModalVisible(!videoModalVisible)
  }

  const toggleOffCanvas = (): void => {
    setVisibleOffCanvas(!visibleOffCanvas)
  }

  const goHeaderDark = (): void => {
    setHeaderDark(true)
  }
  const goHeaderLight = (): void => {
    setHeaderDark(false)
  }

  const goFooterDark = (): void => {
    setFooterDark(true)
  }
  const goFooterLight = (): void => {
    setFooterDark(false)
  }

  const incCartTotal = (): void => {
    setCartTotal(cartTotal + 1)
  }
  const decCartTotal = (): void => {
    setCartTotal(cartTotal - 1)
  }

  return (
    <ReduxWrapper>
      <GlobalContext.Provider
        value={{
          location,
          saveLocation,
          themeDark,
          toggleTheme,
          headerDark,
          goHeaderDark,
          goHeaderLight,
          footerDark,
          goFooterDark,
          goFooterLight,
          videoModalVisible,
          toggleVideoModal,
          visibleOffCanvas,
          toggleOffCanvas,
          cartTotal,
          incCartTotal,
          decCartTotal,
        }}
      >
        {children}
      </GlobalContext.Provider>
    </ReduxWrapper>
  )
}

export default GlobalContext
export { GlobalProvider }
